export interface AcceptOrderRequest {
  id: number
  isTemporary: boolean
  collectionNo: string
  buyBranchCode: string
  collectionType: string
  handlingType: string
  acceptDate: string
  mark: string
  ndc: string
  book: string
  sub: string
  publishDate: string
  shelfType: string
  appendixCode: string
  acceptType: string
  acceptPrice: number
  traderCode: string
  revision: number
  _reserveAssign?: boolean
  icTagUid?: string
}

export function AcceptOrderRequestToJSON(value: AcceptOrderRequest): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    buy_branch_code:
      value.buyBranchCode !== '' ? value.buyBranchCode : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    accept_date: value.acceptDate !== '' ? value.acceptDate : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    book: value.book !== '' ? value.book : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    publish_date: value.publishDate !== '' ? value.publishDate : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    accept_price: value.acceptPrice !== 0 ? value.acceptPrice : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    revision: value.revision !== 0 ? value.revision : undefined,
    _reserve_assign: value._reserveAssign ?? undefined,
    ic_tag_uid: value?.icTagUid || undefined
  }
}
